import styled from "styled-components";

export const SectionList = styled.ul`
  max-height: 25vh;
  overflow-y: auto;
  margin: 0;
  padding: var(--global-spacing-m);
  list-style: none;

  & > li:not(:first-child) {
    margin-top: var(--global-spacing-s);
  }
`;
